import React from 'react'
import * as UI from '@brewlogix/blx-ui'
import { Asset } from 'src/types/schema/graphql'

interface ISingleSquareImage {
    asset: Asset
}

const SingleRectImage: React.FC<ISingleSquareImage> = ({ asset }) => {
    return (
        <div
            key={asset?.id}
            className='col-span-1 row-span-1 hidden overflow-hidden rounded-lg sm:block'
        >
            <UI.Media
                asset={asset}
                width={306}
                height={227}
                customWrapperClasses='object-cover h-full'
                customClasses='h-full max-h-full w-full object-cover'
            />
        </div>
    )
}
export default SingleRectImage
